<template>
  <div class="component image" :data-type="type" data-viewport data-medusa-animation="image">
    <a v-if="data.content.is3d" href="https://cdn.instavr.co/html/YM9lVN5zT27udMGgFn6v_app.html?bust=vb6pgk40mxn" target="_blank">
      <div class="image__title" v-if="data.content.title" v-html="data.content.title"></div>
      <div class="image__picture" ref="image">
        <div class="image__picture-actual" :style="{ 'background-image': `url('${ data.content.image }')` }"></div>
      </div>
      <div class="image__price" v-if="data.content.price" v-html="data.content.price"></div>
      <div class="image__smalltext" v-if="data.content.smalltext" v-html="data.content.smalltext"></div>
      <div class="image__eyelet" v-if="data.content.eyelet" data-medusa-animation="slide">
        <div v-html="data.content.eyelet"></div>
      </div>
    </a>
    <div v-else>
      <div class="image__title" v-if="data.content.title" v-html="data.content.title"></div>
      <div class="image__picture" ref="image">
        <div class="image__picture-actual" :style="{ 'background-image': `url('${ data.content.image }')` }"></div>
      </div>
      <div class="image__price" v-if="data.content.price" v-html="data.content.price"></div>
      <div class="image__smalltext" v-if="data.content.smalltext" v-html="data.content.smalltext"></div>
      <div class="image__eyelet" v-if="data.content.eyelet" data-medusa-animation="slide">
        <div v-html="data.content.eyelet"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import WebGLImage from '@/scripts/webgl/WebGLImage';

export default {
  name: 'ImageBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    type: {
      type: String,
      required: false,
      default: () => 'full',
    },
    first: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasScale: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //   this.WebGLImage = new WebGLImage(this, this.$refs.image, this.data.content.image);
    // });
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 100%;

  &__picture {
    overflow: hidden;
  }

  &__picture-actual {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  &[data-type="full"] {
    padding: $vertical-padding 0;

    .image__picture {
      width: 100%;
      height: 80vh;
      height: calc(var(--vh, 1vh) * 100);
    }
  }

  &[data-type="big"] {
    padding: $vertical-padding $horizontal-padding;

    @include mq($until: ipadL) {
      padding: $mobile-vertical-padding $mobile-horizontal-padding;
    }

    .image__picture {
      width: 100%;
      height: calc(1080px * var(--rw));

      @include mq($until: ipadL) {
        height: calc(540px * var(--rw));
      }
    }
  }

  &[data-type="half"] {
    padding: $vertical-padding $extra-horizontal-padding;

    @include mq($until: ipadL) {
      padding: $mobile-vertical-padding $extra-mobile-horizontal-padding;
    }

    .image__picture {
      width: calc(960px * var(--rw));
      height: calc(1080px * var(--rw));

      @include mq($until: ipadL) {
        width: 100%;
        height: calc(540px * var(--rw));
      }
    }
  }

  &[data-type="multiple"] {
    .image__picture {
      width: 100%;
    }
  }

  &__title {
    margin: 30px 0px;
    font-size: rem(65px);
    font-size: calc(65px * var(--rw));
    line-height: rem(65px);
    line-height: calc(65px * var(--rw));

    text-align: center;
  }

  &__price {
    margin: 30px 0px;
    font-size: rem(36px);
    font-size: calc(36px * var(--rw));
    line-height: rem(48px);
    line-height: calc(48px * var(--rw));

    text-align: center;
  }

  &__smalltext {
    margin: -25px 0px;
    text-align: center;
    font-size: 14px;
    color: $color-white;
  }

  &__eyelet {
    margin: 20px 0px;
    overflow: hidden;
  }
}
</style>
